(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

// import Common from './es6/Common';
// const showNames = 0,
// 	  currentIndex = 0;

// const toggleNames = (event: Event) => {
// 	event.preventDefault();
// 	let rendNames = $('#render_names'),
// 		currLabel = rendNames.text(),
// 		newLabel = (currLabel === 'DISPLAY RESIDENTS' ? 'HIDE RESIDENTS' : 'DISPLAY RESIDENTS'),
// 		show = (currLabel === 'DISPLAY RESIDENTS' ? true : false),
// 		actual_names = $('#actual_names').val().split(':: ');

// 	$('.resident_label').each(function(index, element){
// 		element = $(element);
// 		let current_resident_count = element.attr('data-count'),
// 			resNum = index + 1
// 		if(show) element.text(actual_names[current_resident_count-1]);
// 		else element.text(`Resident ${resNum}`);
// 		rendNames.text(newLabel);
// 	});
// 	return false;
// }

// (function(){
// 	const render_names = document.getElementById('render_names');
// 	render_names.addEventListener('click', toggleNames);
// })();

var showNames = 0;
var currentIndex = 0;
$(document).ready(function (e) {

	// if (typeof sampleImages !== 'undefined')

	if (sampleImages == '') sampleImages = '[]';
	sampleImages = JSON.parse(sampleImages);

	// $('#render_names').click(function() {
	// 	var rendNames = $('#render_names');
	//        var currLabel = rendNames.text();
	//        var newLabel = (currLabel == 'DISPLAY SAMPLES') ? 'HIDE SAMPLES' : 'DISPLAY SAMPLES';
	//        // show display names
	//        var actual_names = $('#actual_names').val();
	//        actual_names = actual_names.split(':: ');
	//     $('.resident_label').each(function(index, element) {
	//         var current_resident_count = $(this).attr('data-count');
	//         var resNum = index + 1;
	//         if(currLabel == 'DISPLAY SAMPLES'){
	//         	 showNames = 1;
	//              $(this).text(actual_names[index]);
	//         }else{
	//         	showNames = 0;
	// 			$(this).text('Resident '+ resNum);
	// 		}
	//   	});
	// rendNames.text('HIDE SAMPLES');

	// 	//popUpMsg('<span class="error_msg" style="color:red;"></span>Please enter your password:<br /><br /><span class="login"><input name="admin_pass" id="admin_pass" type="password" value="" /></span><br /><br /><button id="submit_admin_pass" style="float:right;margin-right:54px;">SUBMIT</button>');
	// });
	//$('#render_names').click();
	$("#edit_nav").sticky({ topSpacing: 0 });

	if (customSignature != '') {
		var sigdiv = $("#signature");
		//init signature
		sigdiv.jSignature();
		sigdiv.jSignature("setData", "data:image/jsignature;base30," + customSignature);
	}

	$('#dateCompletion').append('<div class="font-weight-regular" style="position:absolute;top:50%;margin-top:-11px;line-height:100%;margin-left:-27.5px;left:50%;">' + todaysDate + '</div>');

	if (isLoggedIn == 1) {
		$('textarea').each(function () {
			$(this).css('height', Number($(this)[0].scrollHeight) + 'px');
		});
	}

	if (isSurvey) {
		$.each($('.report_row'), function (index, value) {
			var wrapContent = $(this).find('.wrap_content');
			var editLocation = $(this).find('.edit_location');
			var height = Math.ceil(wrapContent.height() / 10) * 10 + 20;
			wrapContent.height(height);
			editLocation.height(height);
		});
	}
});

$(document).on('click', '#submit_admin_pass', function () {
	var admin_pass = $('#admin_pass').val();
	$.post('/_includes/log-in.php', { action: 'user_confirmation', admin_pass: admin_pass }, function (data) {
		if (data.conf) {
			//         var rendNames = $('#render_names');
			//         var currLabel = rendNames.text();
			//         var newLabel = (currLabel == 'DISPLAY RESIDENTS') ? 'HIDE RESIDENTS' : 'DISPLAY RESIDENTS';
			//         // show display names
			//         var actual_names = $('#actual_names').val();
			//         actual_names = actual_names.split(':: ');
			//         $('.resident_label').each(function(index, element) {
			//             var current_resident_count = $(this).attr('data-count');
			//             var resNum = index + 1;
			//             if(currLabel == 'DISPLAY RESIDENTS'){
			//             	showNames = 1;
			//                 $(this).text(actual_names[current_resident_count-1]);
			//             }else{
			//             	showNames = 0;
			// 	$(this).text('Resident '+ resNum);
			// }
			//       	});
			//      rendNames.text(newLabel);
			//      removePopUpAndOverlay();
		} else {
			// update pop up that passowrd is wrong
			$('.error_msg').html('Invalid password.<br />');
		}
	}, 'json');
});

$(document).on('click tap', '#edit_form', function () {
	if (isLoggedIn == 1) {
		if ($(this).text() == 'RESET') {
			location.reload();
		}
		$('#save_form').css('display', 'inline-block');
		$(this).text('RESET');
		$('.edit_location').each(function () {
			var cur_height = parseInt($(this).css('height')) - 70,
			    cur_content = $.trim($(this).html()),
			    cur_td_uid = $(this).attr('id');

			$(this).css({ 'padding': 0, 'padding-right': '2px' });
			$(this).html('<textarea class="poc_data" rel="' + cur_td_uid + '" style="width:100%;min-height:' + cur_height + 'px; border:none;">' + cur_content + '</textarea>');
		});
		tinymce.init({
			selector: ".edit_location textarea",
			theme: "modern",
			skin: 'lightgray',
			skin_url: '/assets/tinymce/skins/lightgray',
			menubar: false,
			toolbar: "undo redo | bold italic underline | bullist numlist | nanospell",
			width: '100%',
			forced_root_block: '',
			nanospell_autostart: false,
			theme_advanced_buttons1: "bold,italic,underline,bullist,numlist",
			theme_advanced_buttons2: "",
			theme_advanced_buttons3: ""
		});

		$(".edit_location textarea").autogrow();
		if (isSurvey) $('#mceu_7').css('top', '-6px');
	} else if (isLoggedIn == 2) {
		var date = new Date();
		var month = date.getMonth();
		var year = date.getFullYear();
		popUpMsg('Please select a CMS-2567 on your <a href="/facility-admin/q-metrics.php?dep_uid=2&ind_month=' + month + '&ind_year=' + year + '">Q-Metrics report</a>.');
		var t = setTimeout(removePopUpAndOverlay, 3500);
	} else if (isLoggedIn == 3) {
		popUpMsg('Please select a CMS-2567 from a <a href="/admin/association-dashboard.php">facilities</a> Q-Metrics report.');
		var t = setTimeout(removePopUpAndOverlay, 3500);
	} else {
		popUpMsg('Please register to edit your CMS-2567.');
		var t = setTimeout(removePopUpAndOverlay, 3500);
	}
}); // end click edit/reset

$(document).on('click', '#save_form', function () {
	if (isLoggedIn == 1) {
		if (isSurvey) {
			popUpMsg('Saving your resident satisfaction surveys, please wait.</p><p style="text-align:center;"><img src="/assets/images/ajax-loader.gif" width="18" />');
		} else {
			popUpMsg('Saving your CMS-2567, please wait.</p><p style="text-align:center;"><img src="/assets/images/ajax-loader.gif" width="18" />');
		}
		tinyMCE.triggerSave();
		var poc_content = {};

		$('.edit_location').each(function (i, el) {
			poc_content[$(this).attr('id')] = $(this).children('textarea').val();
		});
		$.post('/facility/CMS2567/overwrite', { poc_override: poc_content, isSurvey: isSurvey, hash: window.hash }, function (data) {
			if (data.data == 'login') {
				if (isSurvey) {
					popUpMsg('Please register to save your survey report.');
				} else {
					popUpMsg('Please register to save your CMS-2567.');
				}
				setTimeout(removePopUpAndOverlay, 3500);
			} else {
				location.reload();
			}
		});
	} else {
		if (isSurvey) {
			popUpMsg('Please register to save your report.');
		} else {
			popUpMsg('Please register to save your CMS-2567.');
		}
		setTimeout(removePopUpAndOverlay, 3500);
	}
}); // end click save


function printSurvey() {

	$.ajax({
		url: $(this).attr('/facility/CMS2567/printSurvey'),
		cache: false,
		method: 'POST',
		data: pdfData,
		dataType: 'text'
	}).done(function (link) {
		if (isSurvey) {
			$('.msg_content').empty();
			$('.ajax_loader').remove();
			$('.msg_content').append('To download your CMS-2567 PDF please <a href="' + link + '" target="_blank" style="text-decoration: underline !important;">click here</a>.');
		} else {
			$('.msg_content').empty();
			$('.ajax_loader').remove();
			$('.msg_content').append('To download your CMS-2567 PDF please <a href="/facility/CMS2567/pdf/' + link + '" target="_blank" style="text-decoration: underline !important;">CLICK HERE</a>.');
		}
	}).fail(function (text) {
		$('.msg_content').empty();
		$('.ajax_loader').remove();
		$('.msg_content').append('Something went wrong! Try again');
	});
}

$(document).on('click', '#print_survey', printSurvey);

$(document).on('click', '#print_form', function () {
	if (isLoggedIn != 1) {
		popUpMsg('To download a PDF version of this document please <a href="/register">register</a>.');
		return;
	}
	popUpMsgSimple('Generating your PDF, please wait.<p style="text-align:center;" class="ajax_loader"><img src="/assets/images/ajax-loader.gif" width="18" /></p>');

	pdfData['show_names'] = showNames;
	pdfData['dep'] = dep_uid;
	var html = $(".mainTable").parent().html();
	//pdfData['html'] = html;

	if (typeof window.isSS === 'undefined') var isSS = false;

	pdfData['type'] = window.isSS == true ? 'ss' : 'member';

	if (isSurvey) {
		//calculate the height of things
		var heights = [];
		var surveyLeft = $('<div class="heightLeft" style="width: 246px;"></div>').appendTo('body');
		var response = $('<div style="width: 410px;"></div>').appendTo('body');
		$.each($('.report_row'), function (index, value) {
			var rowHeight = {};
			$(surveyLeft).empty();
			$(surveyLeft).append($(this).find('.wrap_content').html() + '</div>');
			rowHeight['left'] = $(surveyLeft).height();

			var responseHeights = {};
			$.each($(this).find('.comments tbody td > div'), function (i, v) {
				$(response).empty();
				$(response).append($(this).html());
				responseHeights[i] = $(response).height() < 50 ? 50 : $(response).height();
			});
			rowHeight['responseHeights'] = responseHeights;
			heights.push(rowHeight);
		});
		$(surveyLeft).remove();
		$(response).remove();
		pdfData['heights'] = JSON.stringify(heights);
	}

	$.ajax({
		url: $(this).attr('data-url'),
		cache: false,
		method: 'POST',
		data: pdfData,
		dataType: 'text'
	}).done(function (link) {
		if (isSurvey) {
			link = '/facility/survey/pdf/' + link;
			$('.msg_content').empty();
			$('.ajax_loader').remove();
			$('.msg_content').append('To download your survey PDF report please <a href="' + link + '" target="_blank" style="text-decoration: underline !important;">click here</a>.');
		} else {
			$('.msg_content').empty();
			$('.ajax_loader').remove();
			$('.msg_content').append('To download your CMS-2567 PDF please <a href="/facility/CMS2567/pdf/' + link + '" target="_blank" style="text-decoration: underline !important;">CLICK HERE</a>.');
		}
	}).fail(function (text) {
		$('.msg_content').empty();
		$('.ajax_loader').remove();
		$('.msg_content').append('Something went wrong! Try again');
	});
});

//popup images
function changeSlideInfo(photos) {
	var html = '';
	if (photos[currentIndex]['title']) {
		html += '<p style="margin-top: 10px !important; text-align:left;font-size:125%;">Title: <span style="font-size: 100% !important;">' + photos[currentIndex]['title'] + '</span></p>';
	}
	if (photos[currentIndex]['description']) {
		html += '<p style="text-align:left;font-size:125%;">Description: <span>' + photos[currentIndex]['description'] + '</span></p>';
	}
	$('.slideSpecificInfo').empty().append(html);
}
function popupPhoto(photos, sampleName) {
	var html = '<ul class="gallery-slider">';
	$.each(photos, function (index, value) {
		html += '<li data-index="' + index + '"><img src="' + photos[index]['cropped'] + '" /></li>';
	});
	html += '</ul>';

	html += '<div class="samplePhotoInfo">';
	html += '<p style="margin-top: 0 !important; line-height: 100%;font-size:125%;">Sample: <span style="font-size: 100% !important;">' + sampleName + '</span></p>';
	html += '<div class="slideSpecificInfo">';
	if (photos[0]['title']) {
		html += '<p style="margin-top: 10px !important; text-align:left;font-size:125%;">Title: <span style="font-size: 100% !important;">' + photos[0]['title'] + '</span></p>';
	}
	if (photos[0]['description']) {
		html += '<p style="text-align:left;font-size:125%;">Description: <span>' + photos[0]['description'] + '</span></p>';
	}
	html += '</div>';
	html += '</div>';
	popup(html, 'body', 'gallery');
	var slider = $('.gallery-slider').lightSlider({
		gallery: true,
		item: 1,
		slideMargin: 0,
		pager: false,
		loop: true,
		onAfterSlide: function onAfterSlide(el) {
			currentIndex = slider.getCurrentSlideCount() - 1;
			changeSlideInfo(photos);
		},
		prevHtml: '<span data-icon="L" class="icon dep_toggle prev_dep pointer"></span>',
		nextHtml: '<span data-icon="R" class="icon dep_toggle next_dep pointer"></span>'
	});
	slider.refresh();
}
function popupOnePhoto(photo, sampleName) {
	var title = photo[0]['title'] != '' ? photo[0]['title'] : 'No name was given to this photo';
	var html = '<div class="inline-block-49 text-left">';
	html += '<img src="' + photo[0]['image'] + '" />';
	html += '</div>';
	html += '<div class="samplePhotoInfo">';
	html += '<p style="margin-top: 0 !important; line-height: 100%;font-size:125%;">Sample: <span style="font-size: 100% !important;">' + sampleName + '</span></p>';
	html += '<p style="font-size:125%;">Title: <span style="font-size: 100% !important;">' + title + '</span></p>';
	html += '<div class="slideSpecificInfo">';
	if (photo[0]['description']) {
		html += '<p style="text-align:left;font-size:125%;line-height:100% !important; padding-bottom: 35px !important;">Description: <span>' + photo[0]['description'] + '</span></p>';
	}
	html += '</div>';
	html += '</div>';
	popup(html, 'body', 'gallery');
}

$(document).on('click', 'a.resident_label', function (e) {
	e.preventDefault();
	var photos = sampleImages[$(this).data('task-id')][$(this).text()];
	var length = 0;
	for (var photo in photos) {
		length++;
	}
	if (length > 1) {
		popupPhoto(photos, $(this).text());
	} else {
		popupOnePhoto(photos, $(this).text());
	}
});

$(document).on('click', '.other_label', function (e) {
	e.preventDefault();
	popupOtherPhoto(otherImages[$(this).data('task-id')][$(this).data('count')], $(this).html());
});

},{}]},{},[1]);
